export default __webpack_public_path__ + "static/media/logo.1c430cb7.svg";